import React, { useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';

const Createteam =()=>{
  const phoneImageRef = useRef(null); // Create a reference for the image
  const { t, i18n } = useTranslation();
  useEffect(() => {
    const target = phoneImageRef.current;
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          target.classList.add('fade-zoom-animation');
        } else {
          target.classList.remove('fade-zoom-animation');
        }
      });
    });

    if (target) {
      observer.observe(target);
    }
    return () => {
      if (target) {
        observer.unobserve(target);
      }
    };

  }, []);

    return(
      <section id="createteam">
        <div className='container my-4 '>
            <div className='ct-title text-center pb-5 poppins-medium'>{t('createteam.title')}</div>
            <div className='row mt-5'>
                <div className='col-md-6 d-flex flex-column justify-content-center mb-4 steps-mt'>
                    <div className="card mb-3 border border-primary rounded w-75" style={{ margin: '0 auto' }}>
                        <div className="card-body step-card">
                            <span className='text-primary h5 fw-bold'>01</span>
                            <span className='step-text text-secondary poppins-regular'>{t('createteam.wayONE')}</span>
                        </div>
                    </div>
                    <div className="card mb-3 border border-primary rounded w-75 " style={{ margin: '0 auto' }}>
                        <div className="card-body step-card">
                            <span className='text-primary h5 fw-bold'>02</span>
                            <span className=' step-text text-secondary poppins-regular'>{t('createteam.wayTWO')}</span>
                        </div>
                    </div>
                    <div className="card mb-3 border border-primary rounded w-75" style={{ margin: '0 auto' }}>
                        <div className="card-body step-card">
                          <span className='text-primary h5 fw-bold'>03</span>
                          <span className=' step-text text-secondary poppins-regular'>{t('createteam.wayTHREE')}</span>
                        </div>
                    </div>
                    <div className="card mb-3 border border-primary rounded w-75" style={{ margin: '0 auto' }}>
                        <div className="card-body step-card">
                           <span className='text-primary h5 fw-bold'>04</span>
                           <span className=' step-text text-secondary poppins-regular'>{t('createteam.wayFOUR')}</span>
                        </div>
                    </div>
                </div>
                <div className='col-md-6 text-center'>
                 <img src="../assets/images/mobile.png" ref={phoneImageRef} className='mobile-img' alt="Phone"/>
                </div>
            </div>
        </div>
      </section>
    );
};

export default Createteam;